import { Component } from '@angular/core';

@Component({
  selector: 'app-blank',
  template: '',
})
export class BlankComponent {}



// WEBPACK FOOTER //
// ./src/app/components/blank/blank.component.ts